import Patricia from './Patricia.png'
import EllisInsurance from './EllisInsurance.png'
import  Daniel from './Daniel.png'
import  VerdantInsurance from './VerdantInsurance.png'
import  JasonJi from './JasonJi.png'
import  DeThomasWealthManagement from './DeThomasWealthManagement.png'
import  AmyHung from './AmyHung.png'
import  GetInsurance from './GetInsurance.png'
import Charlie from './Charlie.png'
import  Franco from './Franco.png'

export const InsuranceAgentsData = [
    {img:  Patricia, 
    name: "Patricia Stevens - Senior Financial Associate",
    about: "✅ I Help Business Owners Grow Their Wealth ✅Protect Them & Their Business ✅ Provide Competitive Group Benefits to their Valuable Employees to obtain Workplace Wellness within their Organization.",
    location: "4300 Steeles Avenue West Unit 31 Vaughan, ON L4L 4C2 Canada",
    number: "(416) 727-3255",
    },
    {img: EllisInsurance  , 
        name: "Ellis Insurance",
        about: "Let my team and I perform an expert financial analysis to determine what protection you and your family deserve.",
        location: "4300 Steeles Avenue W Suite 31 Vaughan, ON L4L 4C2 Canada",
        number: "(647) 973-5547",
    },
    {img: Daniel , 
    name: "Daniel Goldhar Insurance Broker",
    about: "Products offered include: Business, Auto, Home, Life, Disability and Critical Illness Insurance and Group Benefits.",
    location: "1 Eglinton Avenue East Suite 415 Toronto, ON M4P 3A1 Canada",
    number: "(647) 339-3133",
    },
    {img: VerdantInsurance, 
    name: "Verdant Insurance",
    about: "Get the Protection You Need with Our Comprehensive Insurance Coverage! Looking for reliable insurance? Look no further! Our insurance policies are designed to give you peace of mind and protect what matters most to you. Whether it's your business, your home, your car, or your loved ones, our insurance coverage has you covered. Why choose us? Trusted and Reliable: With years of experience in the insurance industry, we have earned a reputation for being trustworthy and reliable.",
    location: "90 Allstate Parkway Suite 202 Markham, ON L3R 6H3 Canada",
    number: "(905) 412-2929",
    },
    {img: JasonJi  , 
    name: "Jason Ji Desjardins Insurance Agent",
    about: "Our mission is to act in the best interests of our clients. We offer the best protection available, help our clients manage the risks of everyday life and support them in the pursuit of their goals",
    location: "203-10830 Bayview Ave Richmond Hill, ON L4S 1L7 Canada",
    number: "(905) 237-8160",
    },
    {img: DeThomasWealthManagement, 
    name: "De Thomas Wealth Management",
    about: "For over 25 years we have provided clients with independent, unbiased and objective financial advice. Our independence allows us to provide truly personalized advice based on our clients unique investment goals and objectives. By promoting a culture of independence, we do not have any outside interference from 'big bank' shareholders which allows us to ensure that our clients best interest are always our number one priority. Our services include financial planning, investment advice, retirement and estate planning, as well as tax planning. Contact us for a free, no obligation financial review. If you are looking for a free, no obligation Financial Review, please give us a call.",
    location: "9033 Leslie Street Unit 1 Richmond Hill, ON L4B 4K3 Canada",
    number: "(905) 731-9800",
    },
    {img: AmyHung, 
    name: "Amy Hung Desjardins Insurance Agent",
    about: "Our Mission is to help manage the risk of everyday life, recover from the unexpected and realize their dreams.",
    location: "507-3601 Highway 7 E Markham, ON L3R 0M3 Canada",
    number: "(905) 474-3286",
    },
    {img: GetInsurance , 
    name: "Get Insurance in Ontario",
    about: "At Get Insurance in Ontario, we understand that insurance can be a confusing and overwhelming topic. That's why we strive to provide personalized and comprehensive solutions that are tailored to your unique needs and goals. Our experienced advisors are committed to delivering exceptional service and expertise that sets us apart from the rest. Whether you're looking for life insurance, health insurance, or financial planning solutions, we're here to help you achieve your dreams and secure your financial future. Trust us to be your partner in protection – contact us today!",
    location: "Toronto, ON M1T 2M5",
    number: "(647) 514-2928 ",
    },
    {img: Charlie , 
    name: "Charlie Popowich Desjardins Insurance Agent",
    about: "Our mission is to act in the best interests of our clients. We offer the best protection available, help our clients manage the risks of everyday life and support them in the pursuit of their goals",
    location: "208-5915 Leslie St North York, ON M2H 1J8 Canada",
    number: "(416) 449-3326",
    },
    {img: Franco , 
    name: "Franco Greco - Primerica Senior Vice President",
    about: "We specialize in helping clients earn more income, become properly protected, debt free and financially independent! Using a holistic approach to diagnosing areas in a clients financial situation and working with different financial products to help Improve it. Specifically, we deal in the area of: Life insurance Investments Debt management Health/dental benefits Disability insurance Travel insurance Auto/home insurance",
    location: "960 Edgeley Boulevard 2Nd Fl Unit 2a Vaughan, ON L4K 4V4 Canada",
    number: "(416) 859-9922",
    }
]